<template>
<header>
    キャンペーン
    <div class="h-left">
        <a @click="
            $router.push({ name: 'profile' });
            setFooter(true);
          "><img src="~@/assets/images/icon02.svg" /></a>
    </div>
</header>

<div id="wrap2">
    <div v-for="(item, index) in campaignList" :key="index">
        <a @click="$router.push({name: 'campaignDetail', query: {campaign_id: item.id}})">
            <div class="list">
                <div class="clearfix">
                    <div class="list-img">
                        <img src="~@/assets/images/logo.svg" />
                    </div>
                    <div class="list-inf">
                        <table>
                            <tr>
                                <td>
                                    <p>
                                        <span class="red b">{{
                          parseInt(item.is_read) !== IS_READ ? "NEW" : ""
                        }}&nbsp;</span>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>
                                        <span class="list-name">{{ item.title }}</span>
                                    </p>
                                    <p>
                                        {{ item.content }}
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </a>
    </div>
</div>
<infinite-loading @infinite="getCampaignList" style="height: 1px" spinner="spiral">
    <template v-slot:no-more>
        <div id="middle"></div>
    </template>
    <template v-slot:no-results>
        <div id="middle" style="width:100%">開催中のキャンペーンはありません。</div>
    </template>
</infinite-loading>
</template>

<script>
import {
    mapGetters,
    mapActions
} from "vuex";
import CONSTANTS from "@/constants";
export default {
    data: () => ({
        pageSize: 10,
        pageCurrent: 1,
        campaignList: [],
        IS_READ: CONSTANTS.IS_READ
    }),
    computed: {
        ...mapGetters(["defaultToken"]),
    },
    mounted() {

    },
    methods: {
        ...mapActions({
            setFooter: "layout/setFooter",
        }),
        getCampaignList($state) {
            if (this.campaignList.length > 0 && this.campaignList.length < this.pageSize) {
                $state.complete();
                return;
            }
            let params = {
                page: this.pageCurrent,
                limit: this.pageSize,
                token: this.defaultToken,
            }
            this.$store.dispatch('profile/getCampaignList', params).then(data => {
                if (data.result[0]) {
                    this.pageCurrent++
                    this.campaignList.push(...data.result)
                    $state.loaded()
                } else {
                    $state.complete()
                }
            }).catch(() => {
                $state.complete()
            })
        }
    }
}
</script>
